import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const rowDefault = {
  id: null,
  tour_title: null,
  m0101_sc_id: null,
  tour_destination: null,
  tour_destination_area: null,
  bidding_start_date: null,
  bidding_end_date: null,
  is_public: 1,
  tour_start_date: null,
  tour_end_date: null,
  tour_accomodation_days: null,
  tour_accomodation_nights: null,
  student_count: null,
  teacher_count: null,
  age_target: null,
  tour_purpose: [''],
  transportation_suggest: [''],
  accomodation_suggest: [''],
  food_suggest: [''],
  tour_guide_suggest: [''],
  insurance_suggest: [''],
  attractions_suggest: [
    {
      attraction_name: '',
      suggested_time: '',
      attraction_remarks: ''
    }
  ],
  addition_info: [''],
  evaluation_criteria: [
    {
      evaluation_title: '',
      evaluation_weight: 0,
      evaluation_remarks: ''
    }
  ],
  files: [],
  selected_companies: {}
}

mutations.RESET = function (state, payload) {
  state.row = JSON.parse(JSON.stringify(rowDefault))
}
mutations.EDIT_BIDDING = function (state, payload) {
  state.row = payload
}
mutations.SCHOOLS = function (state, payload) {
  state.schools = payload
}
mutations.TOUR_COMPANIES = function (state, payload) {
  state.tourCompanies = payload
}
mutations.AVAILABLE_COUNTRIES = function (state, payload) {
  state.availableCountries = payload
}
mutations.BIDDING_GUIDE = function (state, payload) {
  state.biddingGuide = payload
}
mutations.RESET_COND = function (state, payload) {
  state.cond = {}
}

const state = {
  rows: {
    draft: [],
    confirmed: [],
    canceled: []
  },
  row: JSON.parse(JSON.stringify(rowDefault)),
  tabIndex: 0,
  cond: {},
  schools: [],
  tourCompanies: [],
  availableCountries: [],
  biddingGuide: {}
}
const actions = {
  init: ({ commit, state }, cond) => {
    console.debug('called M0301Bidding init')
    return client.postData({ data: { init: { api: 'M0301BiddingService.getInit', input: cond } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('FIND_ALL', data.init.output.bidding)
          commit('SCHOOLS', data.init.output.schools)
          commit('TOUR_COMPANIES', data.init.output.tourCompanies)
          commit('AVAILABLE_COUNTRIES', data.init.output.availableCountries.map(item => item.tour_destination))
          commit('BIDDING_GUIDE', data.init.output.biddingGuide)
        }
      }).catch((err) => { throw err })
  },
  doSearch: ({ commit, state }, condition) => {
    console.debug('called M0301Bidding search')
    return client.postData({ data: { search: { api: 'M0301BiddingService.doSearch', input: condition } } })
      .then((data) => {
        if (data.search.output.status === false) { throw new Error(data.search.output.message) } else {
          commit('FIND_ALL', data.search.output)
        }
      }).catch((err) => { throw err })
  },
  doDelete: ({ commit }, id) => {
    console.debug('called M0301Bidding delete')
    return client.postData({ data: { delete: { api: 'M0301BiddingService.doDelete', input: id } } })
      .then((data) => {
        commit('FIND_ALL', data.delete.output)
        commit('RESET')
      }).catch((err) => { throw err })
  },
  doCancel: ({ commit }, id) => {
    console.debug('called M0301Bidding cancel')
    return client.postData({ data: { cancel: { api: 'M0301BiddingService.doCancel', input: id } } })
      .then((data) => {
        commit('FIND_ALL', data.cancel.output)
        commit('RESET')
      }).catch((err) => { throw err })
  },
  doSave: ({ commit, state }, row) => {
    console.debug('called M0301Bidding save')
    return client.postData({ data: { save: { api: 'M0301BiddingService.doSave', input: row } } })
      .then((data) => {
        if (data.save.output.status === false) { throw new Error(data.save.output.message) } else {
          commit('FIND_ALL', data.save.output)
        }
      }).catch((err) => { throw err })
  },
  doEdit: ({ commit, state }, id) => {
    console.debug('called M0301Bidding edit')
    return client.postData({ data: { edit: { api: 'M0301BiddingService.doEdit', input: { id: id.id } } } })
      .then((data) => {
        if (data.edit.output.status === false) { throw new Error(data.edit.output.message) } else {
          commit('EDIT_BIDDING', data.edit.output)
        }
      }).catch((err) => { throw err })
  },
  doClone: ({ commit, state }, id) => {
    console.debug('called M0301Bidding clone')
    return client.postData({ data: { clone: { api: 'M0301BiddingService.doClone', input: { id: id.id } } } })
      .then((data) => {
        if (data.clone.output.status === false) { throw new Error(data.clone.output.message) } else {
          commit('EDIT_BIDDING', data.clone.output)
        }
      }).catch((err) => { throw err })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
